export enum ObjectStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  None = 'None',
  Publication = 'Publication',
}
